import React, { useEffect, useMemo, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { Card, CardContent } from "../ui/card";

const rawData = [
  { year: '2010', 'Granel Sólido': 509, 'Granel Líquido': 209, 'Carga Geral': 45, 'Contêineres': 74 },
  { year: '2011', 'Granel Sólido': 554, 'Granel Líquido': 217, 'Carga Geral': 46, 'Contêineres': 87 },
  { year: '2012', 'Granel Sólido': 563, 'Granel Líquido': 212, 'Carga Geral': 46, 'Contêineres': 97 },
  { year: '2013', 'Granel Sólido': 600, 'Granel Líquido': 219, 'Carga Geral': 48, 'Contêineres': 101 },
  { year: '2014', 'Granel Sólido': 622, 'Granel Líquido': 227, 'Carga Geral': 50, 'Contêineres': 100 },
  { year: '2015', 'Granel Sólido': 629, 'Granel Líquido': 232, 'Carga Geral': 53, 'Contêineres': 100 },
  { year: '2016', 'Granel Sólido': 631, 'Granel Líquido': 222, 'Carga Geral': 58, 'Contêineres': 108 },
  { year: '2017', 'Granel Sólido': 709, 'Granel Líquido': 231, 'Carga Geral': 55, 'Contêineres': 113 },
  { year: '2018', 'Granel Sólido': 707, 'Granel Líquido': 235, 'Carga Geral': 63, 'Contêineres': 117 },
  { year: '2019', 'Granel Sólido': 675, 'Granel Líquido': 252, 'Carga Geral': 61, 'Contêineres': 120 },
  { year: '2020', 'Granel Sólido': 710, 'Granel Líquido': 290, 'Carga Geral': 61, 'Contêineres': 128 },
  { year: '2021', 'Granel Sólido': 729, 'Granel Líquido': 325, 'Carga Geral': 63, 'Contêineres': 133 },
  { year: '2022', 'Granel Sólido': 720, 'Granel Líquido': 314, 'Carga Geral': 61, 'Contêineres': 128 },
  { year: '2023', 'Granel Sólido': 787, 'Granel Líquido': 309, 'Carga Geral': 61, 'Contêineres': 128 },
  { year: '2024', 'Granel Sólido': 790, 'Granel Líquido': 314, 'Carga Geral': 65, 'Contêineres': 153 },
];

export default function CargoTypeChart() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // ticks explícitos para garantir TODOS os anos (inclui 2023)
  const allTicks = useMemo(() => rawData.map(d => d.year), []);
  // Ticks curtos no mobile (mas mantendo TODOS)
  const tickFormatterX = (v) => (isMobile ? `'${String(v).slice(2)}` : v);

  return (
    <Card>
      <CardContent className="p-2 pt-6">
        <ResponsiveContainer width="100%" height={320}>
          <BarChart
            data={rawData}
            margin={{ top: 8, right: 8, bottom: isMobile ? 18 : 8, left: 0 }}
            barCategoryGap={isMobile ? '22%' : '16%'}
          >
            <CartesianGrid vertical={false} stroke="#e5e7eb" strokeDasharray="3 3" />

            <XAxis
              dataKey="year"
              ticks={allTicks}
              interval={0}                // força exibir todos os ticks
              stroke="#888888"
              fontSize={isMobile ? 11 : 12}
              tickLine={false}
              axisLine={false}
              height={isMobile ? 26 : 20}
              tick={{ angle: isMobile ? -15 : 0, textAnchor: isMobile ? 'end' : 'middle' }}
              tickFormatter={tickFormatterX}
            />

            <YAxis
              stroke="#888888"
              fontSize={12}
              tickLine={false}
              axisLine={false}
              width={40}
              tickFormatter={(value) => `${value}M`}
              domain={[0, 'dataMax + 120']} // folga no topo
            />

            <Tooltip  cursor={{ fill: 'transparent' }}
              formatter={(value) => [`${value}M`, '']}
              labelFormatter={(label) => `Ano: ${label}`}
              contentStyle={{
                backgroundColor: 'rgba(255,255,255,0.9)',
                backdropFilter: 'blur(6px)',
                border: '1px solid #e5e7eb',
                borderRadius: '0.5rem',
              }}
            />

            <Legend wrapperStyle={{ fontSize: '12px' }} />

            {/* Ordem de empilhamento: a última é o topo -> recebe radius */}
            <Bar dataKey="Granel Sólido"  fill="#0369a1" stackId="a" />
            <Bar dataKey="Granel Líquido" fill="#0891b2" stackId="a" />
            <Bar dataKey="Contêineres"    fill="#a855f7" stackId="a" />
            <Bar dataKey="Carga Geral"    fill="#f97316" stackId="a" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
